import DownloadableTable from './downloadableTable.component';

export default DownloadableTable;